import Myfooter from './footer.module.css'
import{Link} from 'react-router-dom'
const Footer = () => {
    return (
        <div className={`app-footer`} id='sai_app_footer'>
            <div className="app-container d-flex flex-column flex-md-row flex-center flex-md-stack py-3 w-100">
                <>
                <div className='text-dark order-2 order-md-1 lh-sm'>
                    <span className='text-muted fw-semibold me-1'>
                        {new Date().getFullYear().toString()} &copy;
                    </span>
                    <Link
                        to='#'
                        className='text-gray-800 text-hover-primary'
                    >
                        Julien Innovations India Pvt. Ltd. All Rights Reserved.
                    </Link> <br/>
                    {/* <span>
                        Technology Partner
                        <Link
                            to='https://softamassindia.com/'
                            className='text-gray-800 text-hover-primary ms-1'
                            target="blank"
                        >
                            Soft Amass India
                        </Link>
                    </span> */}
                </div>
                

                <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                    <li className='menu-item'>
                        <a href='https://softamassindia.com/terms' target="_blank" className='menu-link px-2'>
                            Terms & Conditions
                        </a>
                    </li>

                    <li className='menu-item'>
                        <a href='https://softamassindia.com/privacy-policy' target="_blank" className='menu-link px-2'>
                            Privacy Policy
                        </a>
                    </li>
                </ul>
                </>
            </div>
        </div>
    )
}

export default Footer;